/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */

import {ConfirmOptions, Connection, Keypair, PublicKey} from '@solana/web3.js';
import idl from './idl.json';
import { Program, Provider, Wallet } from '@project-serum/anchor';
import { Message } from './Messages';
const programID = new PublicKey(idl.metadata.address);

export const GLOBAL_ACCOUNT = new PublicKey("2dpPY1fdADapsAnfVfMhtLxfTaRZyArN1RCxVZ7Mwq53");
/**
 * @private
 */

// const connection = new Connection('http://localhost:8899', 'confirmed');
const opts: ConfirmOptions = {
  preflightCommitment: "processed",
}

 const programs: Record<string, Program> = {};

 export const getProgram =  (wallet: Wallet, connection: Connection): Program => {
   if (wallet.publicKey.toString() in programs) {
     return programs[wallet.publicKey.toString()];
   }
  const provider = new Provider(connection, wallet, opts);
  // @ts-ignore
  const program = new Program(idl, programID, provider);
  programs[wallet.publicKey.toString()] = program;
  return program;

 };


export async function generateKeypairFromSeed(fromPublicKey: PublicKey,
  seed: string,
  programId: PublicKey
): Promise<Keypair> {
  const seedPubKey = await PublicKey.createWithSeed(fromPublicKey, seed, programId);
  const seedBytes = seedPubKey.toBytes()
  return Keypair.fromSeed(seedBytes)
}


export function sortMessages(a: Message, b:Message) {
  if (a.ts === b.ts) {
    return 0;
} else {
    return a.ts > b.ts ? -1 : 1;
}    }
